module.exports = __webpack_public_path__ + "images/lexuse477bbfbdb276683695e7b793ee0f9c9.png";